module.exports = {};



//////////////////
// WEBPACK FOOTER
// /code/frontend/~/core-js/modules/_iterators.js
// module id = ../../../../core-js/modules/_iterators.js
// module chunks = 0